var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"dashboard"},[_c('Navigation'),(_vm.loader)?_c('LoaderCircle'):_c('div',{staticClass:"dashboard__inner"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }